import axios from 'axios';

let appConfigs;
let apiClient;

if (!apiClient) {
	apiClient = axios.create();
}

export default async () => {
	if (!appConfigs) {
		appConfigs = await apiClient.get(process.env.VUE_APP_APPCONFIG_URL);
	}

	return appConfigs.data;
};
